import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "1. Introduction and Scope",
    body: `Gromza ("we", "our", or "us") is committed to protecting the privacy of our users ("you", "your", or "Shopkeepers/Merchants"). This Privacy Policy is a legally binding document between you and Gromza. It explains how we collect, use, disclose, and safeguard your information when you visit our mobile application and use our services, including QR generation, subscription management, and payment processing. By using Gromza, you consent to the data practices described in this policy. If you do not agree with the terms, please discontinue use immediately.`,
  },
  {
    title: "2. Information We Collect",
    body: `A. Personal Data — Registration Info: name, business name, and email address. Contact Info: mobile number for OTP verification and WhatsApp support. KYC Data: if required by payment aggregators for Razorpay integration.\nB. Business & QR Data — QR Content: information you embed in your QR codes (links, UPI IDs, text). Transaction Logs: history of subscriptions purchased within the app.\nC. Technical & Usage Data — Device ID: unique identifiers to prevent multi-device login abuse. Analytics: logs of app crashes, screen views, and interaction patterns.`,
  },
  {
    title: "3. Legal Basis for Processing",
    body: `We process your data under the following legal frameworks: Contractual Necessity — to provide the subscription services you paid for. Consent — when you explicitly agree to our terms during signup. Legal Obligation — to maintain records for tax (GST) and audit purposes as per Indian Law.`,
  },
  {
    title: "4. Third-Party Integrations & Data Sharing",
    body: `Gromza works with industry-standard partners. We do not "sell" your data; we "share" it only for functionality: Emergent — for hosting, database management, and authentication. Razorpay — for secure payment processing; your card/bank details are encrypted and handled by Razorpay, and Gromza does not store CVVs or PINs. Expo — to manage the app framework and push notifications.`,
  },
  {
    title: "5. Subscription & Payment Policy",
    body: `Billing: all subscriptions are billed in advance. Automatic Renewal: if enabled, your account will be charged 24 hours before the period ends. Refunds: under the Consumer Protection Act, if a service is not delivered as promised, users can claim a refund within the specified window.`,
  },
  {
    title: "6. Data Retention and Account Deletion",
    body: `Retention: we keep your data as long as your account is active. Account Deletion: you have the right to delete your account. Upon request, we will initiate a 30-day grace period before permanently wiping your data, unless required for legal/financial audits.`,
  },
  {
    title: "7. Security Measures",
    body: `We implement SSL encryption, security rules, and restricted API access to protect your data. However, remember that no method of transmission over the internet is 100% secure.`,
  },
  {
    title: "8. Grievance Redressal",
    body: `In compliance with Information Technology (Intermediary Guidelines) Rules, the contact details for our Grievance Officer are: Name: Akash Kumar. Address: Patna, Bihar, India. Email: akashkumar8651.ak@gmail.com. WhatsApp: +91 8651938731.`,
  },
  {
    title: "9. User Rights",
    body: `You have the right to: Access — request a copy of the data we hold. Rectify — update incorrect business information. Withdraw — cancel consent at any time (this may limit app functionality).`,
  },
];

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-[#0b0f19] text-white">
      <div className="max-w-3xl mx-auto px-6 py-20">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors mb-12"
        >
          <ArrowLeft size={16} /> Back to Gromza
        </Link>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-400 mb-4">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight mb-14">
          Privacy <span className="gold-text">Policy</span>
        </h1>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={s.title} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display text-xl font-semibold text-amber-100 mb-3">{s.title}</h2>
              {s.body.split("\n").map((p, j) => (
                <p key={j} className="text-sm text-slate-400 leading-relaxed mb-2">{p}</p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
